import styles from "../rankings.module.css";

export default function AchievementCard({ achievement }) {
  if (!achievement) return null;
  return (
    <article className={styles.achCard} data-testid="achievement-card">
      <h3>{achievement.title}</h3>
      <p className={styles.muted}>{achievement.detail}</p>
    </article>
  );
}
